export const TOKEN = "TOKEN";
export const BLOG_DATA = "BLOG_DATA";